import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SellerFormComponent } from '../../seller/form/form.component';
import { UserService } from 'src/app/services/user.service';
import { InquiryService } from 'src/app/services/inquiry.service';
import { UpgradePackageComponent } from '../upgrade-package/upgrade-package.component';

@Component({
  selector: 'app-inquiry-button',
  templateUrl: './inquiry-button.component.html',
  styleUrl: './inquiry-button.component.scss',
  standalone:false
})
export class InquiryButtonComponent {
  @Input() label:string = ''
  @Input() company_id:string = ''
  @Input() company_type:string = ''
  @Input() country_id:number = 0

  is_inquiry_loading = false

  constructor(
    public dialog: MatDialog,
    private userService : UserService,
    private inquiryService : InquiryService,
  ){}

  onClick(){
    if(!this.userService.isLoggedIn()){
      this.dialog.open(SellerFormComponent)
      return
    }

    const access_roles = {
			1 : 'tile_manufacture',
			2 : 'sanitary_manufacture',
			3 : 'various_manufacture',
			4 : 'trader',
			5 :  this.country_id !== 1 ? 'dealer_india' : 'dealer_other',
			6 : 'transporter',
			7 : 'supplier',
			8 : 'hotel',
			9 : 'service_provider',
			10 : 'cab',
		}
    const access = this.userService.getAccessRoleByType(access_roles[this.company_type])
    const is_allowed = access['inquiry'] ?? false 

    if (!is_allowed) {
      this.dialog.open(UpgradePackageComponent)
      return ;
    }

    this.sendInquiry()
  }

  sendInquiry(): void {
    this.is_inquiry_loading = true
    let user = this.userService.getUser();
    let company = user.company.id ? user.company.id : 0;
    this.inquiryService
      .save({ from_company_id: company, to_company_id: this.company_id })
      .subscribe((res) => {
        if (res.success) {
          this.userService.sucessMessage(res.message);
        } else {
          this.userService.errorMessage(res.message);
        }
        this.is_inquiry_loading = false
      });
  }
}
